var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "money-dollar-svgrepo-com 1",
    clipPath: "url(#clip0_9726_5581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9726_5581",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_443_3628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 0H0V30H30V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9726_5581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.5 7.5H2.5V22.5H27.5V7.5Z",
    stroke: "#A182DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.5 12.5C26.8434 12.5 26.1932 12.3707 25.5866 12.1194C24.98 11.8681 24.4288 11.4998 23.9645 11.0355C23.5001 10.5712 23.1319 10.02 22.8806 9.41341C22.6294 8.80679 22.5 8.15661 22.5 7.5H27.5V12.5Z",
    stroke: "#A182DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.5 22.5C22.5 21.1739 23.0268 19.9021 23.9645 18.9645C24.9021 18.0268 26.1739 17.5 27.5 17.5V22.5H22.5Z",
    stroke: "#A182DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.5 17.5C3.82609 17.5 5.09785 18.0268 6.03554 18.9645C6.97321 19.9021 7.5 21.1739 7.5 22.5H2.5V17.5Z",
    stroke: "#A182DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.5 7.5C7.5 8.82609 6.97321 10.0979 6.03554 11.0355C5.09785 11.9732 3.82609 12.5 2.5 12.5V7.5H7.5Z",
    stroke: "#A182DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.5926 11.875H14.1666C13.2462 11.875 12.5 12.5745 12.5 13.4375C12.5 14.3005 13.2462 15 14.1666 15H16.3889C17.3094 15 18.0555 15.6995 18.0555 16.5625C18.0555 17.4255 17.3094 18.125 16.3889 18.125H12.5",
    stroke: "#A182DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15 11.8967V10.625",
    stroke: "#A182DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15 19.3966V18.125",
    stroke: "#A182DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9726_5581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyDollar);
export default __webpack_public_path__ + "static/media/money-dollar.317e4b6e588f973b909ae47fca8d74a0.svg";
export { ForwardRef as ReactComponent };